// src/store/slices/toastSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ToastState {
  message: string;
  visible: boolean;
}

const toastSlice = createSlice({
  name: 'toast',
  initialState: { message: '', visible: false } as ToastState,
  reducers: {
    showToast: (state, action: PayloadAction<string>) => {
      state.message = action.payload;
      state.visible = true;
    },
    hideToast: (state) => { state.visible = false; },
  },
});

export const { showToast, hideToast } = toastSlice.actions;
export default toastSlice.reducer;
